import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'unh-depoimentos-item',
  templateUrl: './depoimentos-item.component.html',
  styleUrls: ['./depoimentos-item.component.scss']
})
export class DepoimentosItemComponent implements OnInit {
  @Input() avatar: any;
  @Input() name: any;
  @Input() specialty: any;
  @Input() rating: any;
  @Input() content: any;

  constructor() { }

  ngOnInit(): void {
  }

}
